@if (visibleContainer) {
  <div class="border border-success rounded" [class.usage-card-grow]="containerGrow" [ngClass]="marginBottom">

    <div class="row">
      <div class="col-12">
        <div
          class="alert border-0 alert-primary d-flex justify-content-between align-items-center"
          [ngClass]="expandContainer ? 'mb-3' : 'mb-0'"
          role="alert"
        >
          <strong>{{chartTitle}}</strong>
          <div class="d-flex align-items-center" style="gap: 6px;">
            @if (userDomains) {
              <span class="badge bg-success-subtle text-success fs-11 d-inline-flex align-items-center gap-1">
                <i class="ri-filter-3-line"></i>
                Filtered to {{ userDomainsText }}
                <button class="btn btn-link btn-sm p-0 ms-1 text-primary lh-1" title="Clear the user domain filter" type="button" (click)="userDomainsClear.emit()"><i class="ri-close-line"></i></button>
              </span>
            }

            @if (expandContainer) {
              <div class="vht-header-dates">
                <div class="vht-date-picker">
                  <span class="vht-date-label">From</span>
                  <app-dropdown-date
                    [allowUndefinedInitialDate]="true"
                    [dateFormat]="dateFormat"
                    [initialDate]="filterDateFrom"
                    title="From"
                    (clearedEvent)="dateFromChanged(undefined)"
                    (selectOnChangeEvent)="dateFromChanged($event)"
                  ></app-dropdown-date>
                </div>

                <div class="vht-date-picker">
                  <span class="vht-date-label">To</span>
                  <app-dropdown-date
                    [allowUndefinedInitialDate]="true"
                    [dateFormat]="dateFormat"
                    [initialDate]="filterDateTo"
                    title="To"
                    (clearedEvent)="dateToChanged(undefined)"
                    (selectOnChangeEvent)="dateToChanged($event)"
                  ></app-dropdown-date>
                </div>
              </div>
            }

            <span
              *ngIf="!expandContainer && showTitleHintText"
              class="text-muted"
              style="font-size: 0.85em;"
            >
              Chart
            </span>
            <i class="fs-5"
               [attr.data-bs-toggle]="'tooltip'"
               [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
               [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
               style="cursor: pointer; color: #198754;"
               (click)="toggleContainerExpansion()">
            </i>
            <i *ngIf="allowContainerClose"
               class="fs-3 bx bx-x"
               [attr.data-bs-toggle]="'tooltip'"
               data-bs-title="Close"
               style="cursor: pointer; color: #dc3545;"
               (click)="closeContainer()">
            </i>
          </div>
        </div>
      </div>
    </div>

    @if (volumeAndHealthTrendChart != undefined) {
      <div class="row" [class.d-none]="!expandContainer">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

              <div class="vht-toolbar">
                <div class="vht-quick-ranges btn-group btn-group-sm" role="group">
                  <button type="button"
                          class="btn"
                          [ngClass]="quickRangeDays===30 ? 'btn-info' : 'btn-soft-info'"
                          (click)="selectQuickRange(30)">30 Days</button>
                  <button type="button"
                          class="btn"
                          [ngClass]="quickRangeDays===90 ? 'btn-info' : 'btn-soft-info'"
                          (click)="selectQuickRange(90)">90 Days</button>
                  <button type="button"
                          class="btn"
                          [ngClass]="quickRangeDays===180 ? 'btn-info' : 'btn-soft-info'"
                          (click)="selectQuickRange(180)">6 Months</button>
                  <button type="button"
                          class="btn"
                          [ngClass]="filterDateFrom===undefined && filterDateTo===undefined ? 'btn-info' : 'btn-soft-info'"
                          (click)="clearDateRange()">All</button>
                </div>

                @if (hiddenSeries.length > 0) {
                  <button type="button"
                          class="btn btn-sm btn-soft-success vht-show-all"
                          (click)="showAllSeries()">
                    <i class="bx bx-reset align-middle me-1"></i>Show All Metrics
                  </button>
                }
              </div>

              <div class="d-flex gap-2">
                <div class="vht-legend">
                  <div class="vht-legend-hint">Click to hide, double click to isolate</div>
                  @for (item of visibleLegendItems; track item.name) {
                    <div
                      [attr.data-bs-title]="isSeriesHidden(item.name) ? 'Show ' + item.name : 'Hide ' + item.name"
                      [attr.data-bs-toggle]="'tooltip'"
                      class="vht-legend-item"
                      [class.vht-legend-item-group-end]="!$last && isLegendGroupEnd(item.name)"
                      [class.vht-legend-item-hidden]="isSeriesHidden(item.name)"
                      [class.vht-legend-item-hovered]="hoveredSeriesName===item.name"
                      [style.--vht-hover-colour]="item.color"
                      (click)="toggleSeries(item.name)"
                      (dblclick)="isolateSeries(item.name)"
                      (mouseenter)="focusSeries(item.name)"
                      (mouseleave)="focusSeries(undefined)"
                    >
                      <span class="vht-legend-swatch" [style.background-color]="item.color"></span>
                      <span class="vht-legend-label">{{ item.name }}</span>
                    </div>
                  }
                </div>
                <div #chartHost class="flex-grow-1 min-width-0">
                  <apx-chart #chartRef
                    [chart]="volumeAndHealthTrendChart.chart"
                    [colors]="volumeAndHealthTrendChart.colors"
                    [dataLabels]="volumeAndHealthTrendChart.dataLabels"
                    dir="ltr"
                    [fill]="volumeAndHealthTrendChart.fill"
                    [grid]="volumeAndHealthTrendChart.grid"
                    [legend]="volumeAndHealthTrendChart.legend"
                    [markers]="volumeAndHealthTrendChart.markers"
                    [plotOptions]="volumeAndHealthTrendChart.plotOptions"
                    [series]="volumeAndHealthTrendChart.series"
                    [stroke]="volumeAndHealthTrendChart.stroke"
                    [subtitle]="volumeAndHealthTrendChart.subtitle"
                    [title]="volumeAndHealthTrendChart.title"
                    [tooltip]="volumeAndHealthTrendChart.tooltip"
                    [xaxis]="volumeAndHealthTrendChart.xaxis"
                    [yaxis]="volumeAndHealthTrendChart.yaxis"
                  >
                  </apx-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else if (noData) {
      <div class="row">
        <div class="col-12">
          <div class="alert alert-danger mb-0 text-center" role="alert">
            @if (userDomains) {
              No user domain history yet. It builds from the next MDM sync onwards.
            } @else {
              No data available
            }
          </div>
        </div>
      </div>
    }

  </div>
}
